import { render, staticRenderFns } from "./EmbedContent.vue?vue&type=template&id=636ba9fc&scoped=true&"
import script from "./EmbedContent.vue?vue&type=script&lang=js&"
export * from "./EmbedContent.vue?vue&type=script&lang=js&"
import style0 from "./EmbedContent.vue?vue&type=style&index=0&id=636ba9fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636ba9fc",
  null
  
)

export default component.exports